import { render } from "./AccountDeletion.vue?vue&type=template&id=476a2446&scoped=true&ts=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=ts"
export * from "./AccountDeletion.vue?vue&type=script&lang=ts"

import "./AccountDeletion.vue?vue&type=style&index=0&id=476a2446&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476a2446"]])

export default __exports__